import React from 'react';
import { Search } from 'lucide-react';

// Reusable filter bar for program lists.
const ProgramFilters = ({ q, setQ, type, setType, status, setStatus, price, setPrice, time, setTime, showStatus = true }) => (
  <div className="flex flex-wrap items-center gap-3">
    <div className="relative flex-1 min-w-[200px]">
      <Search className="w-4 h-4 text-mahogany/50 absolute left-3 top-1/2 -translate-y-1/2" />
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search by title…"
        className="w-full bg-white/70 rounded-full border border-rose/50 pl-9 pr-4 py-2 text-sm text-burgundy focus:outline-none"
      />
    </div>
    <Dropdown value={type} onChange={setType} options={[['', 'All types'], ['event', 'Events'], ['retreat', 'Retreats'], ['class', 'Classes']]} />
    {showStatus && <Dropdown value={status} onChange={setStatus} options={[['', 'All statuses'], ['draft', 'Draft'], ['pending', 'Pending'], ['approved', 'Approved'], ['rejected', 'Rejected']]} />}
    <Dropdown value={price} onChange={setPrice} options={[['', 'Any price'], ['free', 'Community-Supported'], ['paid', 'Paid']]} />
    <Dropdown value={time} onChange={setTime} options={[['', 'Any time'], ['upcoming', 'Upcoming'], ['past', 'Past']]} />
  </div>
);

const Dropdown = ({ value, onChange, options }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)}
    className="bg-white/70 rounded-full border border-rose/50 px-4 py-2 text-sm text-burgundy focus:outline-none">
    {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
  </select>
);

// Apply the filters to a list of programs (client-side).
export const applyProgramFilters = (items, { q, type, status, price, time }) => {
  const now = Date.now();
  return items.filter((p) => {
    if (q && !(`${p.title || ''}`.toLowerCase().includes(q.toLowerCase()))) return false;
    if (type && p.type !== type) return false;
    if (status && p.status !== status) return false;
    if (price === 'free' && !p.is_free) return false;
    if (price === 'paid' && p.is_free) return false;
    if (time) {
      const end = p.end_datetime || p.start_datetime;
      const isPast = end ? new Date(end).getTime() < now : false;
      if (time === 'upcoming' && isPast) return false;
      if (time === 'past' && !isPast) return false;
    }
    return true;
  });
};

export default ProgramFilters;
